
/**
 * The field by which the users should be sorted.
 * @export
 * @enum {string}
 */
export enum UserSortField {
    EMAIL = 'EMAIL',
    FIRST_NAME = 'FIRST_NAME',
    LAST_NAME = 'LAST_NAME',
    ROLE = 'ROLE',
    VENDOR = 'VENDOR'
}